import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import laptopImg from "../../Assets/about.png";

function Services() {
  return (
    <Container fluid className="about-section pt-5">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", alignItems: "center",padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "60px",
              paddingBottom: "50px",
            }}
          >
            <h2 style={{ fontSize: "2.6" }}>
               <span className="purple"> OUR SERVICES </span>
            </h2>
            <p className="home-about-body">
              At Youkish Tech, we offer a range of expert technology solutions designed to help businesses grow and thrive in the digital world. From custom software development to mobile apps, we have the skills to bring your ideas to life.
            </p>
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
          <Col
            md={12}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "10px",
            }}
          >
            <h2 style={{ fontSize: "1.5em" }}>
               <span className="purple"> Custom Software Development </span>
            </h2>
            <p className="home-about-body pt-0">
              We create tailor-made software solutions that fit your business needs, improving efficiency and scalability.
            </p>
          </Col>
          <Col
            md={12}
            style={{
              justifyContent: "center",
              paddingTop: "10px",
              paddingBottom: "10px",
            }}
          >
            <h2 style={{ fontSize: "1.5em" }}>
               <span className="purple"> Mobile App Development </span>
            </h2>
            <p className="home-about-body pt-0">
              Our team builds intuitive and feature-rich mobile apps that provide seamless experiences for your customers.
            </p>
          </Col>
          <Col
            md={12}
            style={{
              justifyContent: "center",
              paddingTop: "10px",
              paddingBottom: "50px",
            }}
          >
            <h2 style={{ fontSize: "1.5em" }}>
               <span className="purple"> Web Development </span>
            </h2>
            <p className="home-about-body pt-0">
              We design and develop responsive websites that engage users and help your business succeed online.
            </p>
          </Col>
        </Row>
        <h2 className="project-heading">
          <strong className="purple">TECHNOLOGIES</strong>
        </h2>
        <Techstack />
      </Container>
    </Container>
  );
}

export default Services;
